module.exports = __webpack_public_path__ + "static/scale-model-of-harlow-house-museum-in-gresham-oregon-e06785f4a7c75fbe786086916b1a64a3.png";